module.exports = __webpack_public_path__ + "static/media/siemens-gamesa.d798cd4e.png";